import { Component, OnInit } from '@angular/core';
import { TiktokPixelService } from 'src/app/services/tiktok-pixel.service';
import * as moment from 'moment';
declare let fbq: Function;

@Component({
  selector: 'app-tiktok',
  templateUrl: './tiktok.component.html',
  styleUrls: ['./tiktok.component.scss'],
})
export class TiktokComponent implements OnInit {
  img = '../../../assets/imgs/tiktok1.jpg';
  contatoTel: string = '5515988339053';

  constructor(private tiktokPixelService: TiktokPixelService) {}

  ngOnInit(): void {
    this.tiktokPixelService.tiktokViewContent();
  }

  textWhats() {
    window.open(
      `https://api.whatsapp.com/send?phone=${this.contatoTel}&text=Ol%C3%A1%2C%20tenho%20interesse%20em%20conhecer%20mais%20sobre%20o%20Yourder`,
      '_blank'
    );

    let hoje = moment().format('DD/MM/yyyy');
    fbq('track', 'Contact', hoje);

    this.tiktokPixelService.contactPixel();
  }
}
